import { joinApi } from '@/shared/api/mailSubscription';
import { setLoading } from '@/shared/services/loading';
import { NOTIFICATIONS, NotificationService } from '@/shared/services/notification';
import type { TMailSubscriptionInitialData } from '@/shared/types/mailSubscription';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { IMailSubscriptionSlice, TActionMailSubscriptionJoin } from './types';

const mainSlice = createSlice({
  name: 'mailSubscription',
  initialState: {
    model: null,
    constants: null,
    settings: {
      SmsTermsContent: '',
      image: {
        url: '',
        alt: '',
      },
      isShowWidget: false,
    },
  } as IMailSubscriptionSlice,
  reducers: {
    setMain: (state, action: PayloadAction<TMailSubscriptionInitialData>) => {
      state.model = action.payload.model;
      state.constants = action.payload.constants;
      state.settings = action.payload.settings;
    },
    setShowWidgetModal: (state, action: PayloadAction<boolean>): void => {
      state.settings!.isShowWidget = action.payload;
    },
  },
});

export const { setMain, setShowWidgetModal } = mainSlice.actions;

export default mainSlice.reducer;

export const firstLoadOfData =
  (payload: TMailSubscriptionInitialData): MailSubscriptionAppThunk =>
  (dispatch) =>
    dispatch(setMain(payload));

export const MailSubscriptionJoin: TActionMailSubscriptionJoin =
  (postData, callback) => async (dispatch) => {
    dispatch(setLoading(true));

    try {
      const response = await joinApi(postData);
      if (!response.Result && !response.Errors) {
        NotificationService.open({
          status: NOTIFICATIONS.ERROR,
          text: 'An error has occurred, the response could not be received. Try again.',
        });
      }

      if (response.Errors && response.Errors.length > 0) {
        response.Errors.forEach((message) => {
          NotificationService.open({
            status: NOTIFICATIONS.ERROR,
            text: message,
          });
        });
      }

      if (response.Result) {
        callback();
      }
    } catch (error) {
      NotificationService.open({
        status: NOTIFICATIONS.ERROR,
        text: (error as Error).message,
      });
    } finally {
      dispatch(setLoading(false));
    }
  };
